<template>
  <div class="card card-stats">
    <div class="card-body">
      <div class="actions-header row">
        <div class="col-1 col-md-2">
            <div class="text-left type-icon"
                    :class="`text-${'light-gray'}`">
                <img :src="'static/img/icons/' + icon"/>
                <div class="event-amount-bubble text-center"><span>{{total}}</span></div>
            </div>
        </div>
        <div class="col-2 col-md-4 text-uppercase text-bold text-left">{{title}}</div>
      </div>
      <hr>
      <div v-for="(event, i) in events" :key="i" class="content row">
        <div class="col-2">
            <div class="content-icon text-left" v-if="type === 'news'">
                <i class="action-icon" :class="event.icon"></i>
            </div>
            <div class="content-number text-left" v-if="type === 'deadlines'">
                <span>{{event.amount}}</span>
            </div>
        </div>
        <div class="col-8">
            <div class="content-news text-left" v-if="type === 'news'">
                <div class="row date category">{{event.date}}</div>
                <div class="row title text-uppercase">{{event.title}}</div>
                <div class="row description">{{event.description}}</div>
            </div>
            <div class="content-deadlines text-left" v-if="type === 'deadlines'">
                <div class="row title text-uppercase">{{event.title}}</div>
                <div class="row date description">{{event.date}}</div>
            </div>
        </div>
        <div class="col-2">

            <p-button class="action-button" aria-label="add button" type="default" round icon size="sm" :style="{ backgroundImage: `url(static/img/icons/button-action.png)` }" @click="createNewOrder(event.action)"></p-button>

        </div>
        <hr class="w-100">
      </div>
      <!-- <div class="row">
        <div class="col-12 col-md-12">
          <slot name="header">
            <div class="action-text text-center"
                 :class="`text-${type}`">
                 <span>{{title}}</span>
            </div>
          </slot>
        </div>
      </div> -->
    </div>

  </div>
</template>
<script>
  export default {
    name: 'actions-card-serviam',
    props:{
      type: {
        type: String,
        description: 'Card text type (primary|info|danger|default|warning|success)'
      },
      title: {
        type: String,
        description: 'Card title'
      },
      icon: {
        type: String,
        description: 'Card icon'
      },
      events: {
        type: Array,
        description: 'Array of event objects'
      },
      total: {
        type: Number,
        description: 'number for bubble'
      },
      method: {
        type: String,
        required: true,
        description: 'Callback method'
      }
    },
    methods: {
        createNewOrder(action) {
            this.$parent[this.$props.method](action)
        }
    }
  }

</script>
<style scoped>
    .card{
        min-height: 400px;
        max-height: 530px;
    }
    .card-category {
        font-weight: bold;
        text-transform: uppercase;
    }
    .card-title {
        font-size: 3em;
        font-style: italic;
    }
    .text-bold {
        font-weight: bold;
    }
    .text-light-gray {
        color: gray;
    }
    .action-text {
        text-transform: uppercase;
        font-weight: bold;
        letter-spacing: 4px;
        font-size: 1.1em;
        text-shadow: 0px 1px, 1px 0px, 1px 1px;
    }
    .action-button {
      background-color: lightgray;
      color: black;
      background-position: center;
      border: 2px solid lightgray;
      background-size: cover;
      right: 10px
    }
    .action-icon {
        margin-top: 60%;
        font-size: 2em;
        color: #d6752d;
    }
    .type-icon {
        font-size: 2em;
    }
    .event-amount-bubble {
        border-radius: 25px;
        width: 1em;
        height: 1em;
        position: absolute;
        top: -10px;
        background-color: #d6752d;
        left: 30px;
    }
    .event-amount-bubble span {
        font-size: 14px;
        position: relative;
        top: -12px;
        font-weight: bold;
        color: white;
    }
    .content-number {
        font-size: 1.5em;
        white-space: nowrap;
    }
    hr {
        margin-top: 0
    }


</style>
